import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { NftTileMedia } from '../NftTileMedia';
import { NftDraftItemTileMedia_nftItemDraft$key } from './__generated__/NftDraftItemTileMedia_nftItemDraft.graphql';

const fragment = graphql`
    fragment NftDraftItemTileMedia_nftItemDraft on NftItemDraft {
        serviceId
        name
        mainMedia {
            mimeType
            originalUrl
            videoThumbUrl
        }
        posterFrameMedia {
            mimeType
            originalUrl
            displayUrl
        }
    }
`;

export const NftDraftItemTileMedia: FC<{
    nftItemDraft: NftDraftItemTileMedia_nftItemDraft$key | null;
    animate: boolean;
}> = ({ nftItemDraft: nftItemDraftRef, animate }) => {
    const { serviceId, name, mainMedia, posterFrameMedia } =
        useFragment(fragment, nftItemDraftRef) ?? {};

    const { mimeType } = mainMedia ?? {};

    return (
        <NftTileMedia
            animate={animate}
            mimeType={mimeType}
            webUrl={mainMedia?.originalUrl}
            videoThumb={mainMedia?.videoThumbUrl}
            posterFrameUrl={posterFrameMedia?.displayUrl || posterFrameMedia?.originalUrl}
            altText={name}
            posterOverrideId={serviceId}
        />
    );
};
